import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { EmploymentStatus } from "@/models/employment-info.model";
import { ColumnDef } from "@tanstack/react-table";
import { ArrowUpDown, MoreHorizontal, Trash2, User } from "lucide-react";
import { DeleteUserDialog } from "../indiv-user-page/DeleteUserDialog";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import EmploymentStatusTag from "@/components/tags/EmploymentStatusTag";
import { User as UserModel } from "@/models/user.model";

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
export type UserInTable = {
  fullName: string;
  email: string;
  userId: string;
  employmentStatus: EmploymentStatus;
};

const ActionCell = ({ row }: { row: any }) => {
  // Replace 'any' with your row type
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const user = row.original;
  const navigate = useNavigate();

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">Open menu</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Actions</DropdownMenuLabel>

        <DropdownMenuSeparator />
        {user.employmentInfo && user.staffInfo && user.paymentInfo ? <DropdownMenuItem
          onClick={() =>
            navigate(`/admin/users/${user.id}`, {
              state: { user },
            })
          }
        >
          <User />
          <div>View</div>
        </DropdownMenuItem> : (<DropdownMenuItem
          onClick={() =>
            navigate(`/admin/onboard/${user.id}`)
          }
        >
          <User />
          <div>Onboard</div>
        </DropdownMenuItem>)}
        <DropdownMenuItem onClick={() => setIsDeleteDialogOpen(true)}>
          <Trash2 />
          <div>Delete</div>
        </DropdownMenuItem>
      </DropdownMenuContent>
      <DeleteUserDialog
        isOpen={isDeleteDialogOpen}
        setIsOpen={setIsDeleteDialogOpen}
        user={user}
      />
    </DropdownMenu>
  );
};

export const columns: ColumnDef<UserModel>[] = [
  {
    accessorFn: (row) => `${row.fullName}`,
    header: "Full Name",
  },

  {
    accessorKey: "email",
    size: 200,
    header: ({ column }) => {
      return (
        <div className="flex items-center gap-2 min-w-[200px]">
          Email
          <button
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </button>
        </div>
      );
    },
  },

  {
    header: "Employment Status",
    accessorKey: "employmentStatus",
    cell: ({ row }) => {
      return (
        <EmploymentStatusTag
          status={
            row.original.employmentInfo?.employmentStatus as EmploymentStatus
          }
        />
      );
    },
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return <ActionCell row={row} />;
    },
  },
];
